import React from "react"

import {
    css,
    FieldLabel,
    Grid,
    GridCell,
    Icon,
    Select,
    TextInput,
    Theme,
} from "@bdfx/mergado-ui-kit"

import trans from "trans"
import { NumericInput } from "./fields"
import TransparentColor from "./transparent-color"
import { Gradient } from "app/types/model-types"
import SelectGradient from "./select-gradient"
import Shape, { BEZIER_TYPE, CIRCLE_TEXT_TYPE, CIRCLE_TYPE, CURVED_TEXT_TYPE, DASHED_FRAME_TYPE, DYNAMIC_TEXT_TYPE, ELLIPSE_TYPE, FRAME_TYPE, IMAGE_TYPE, LINE_TYPE, NONE_TYPE, POLYGON_TYPE, RATING_TYPE, RECTANGLE_EACH_LINE_TYPE, RECTANGLE_TYPE, TEXT_INSIDE_SHAPE_TYPE, TEXT_TYPE, TEXT_WITH_ELEMENTS_TYPE, TRIANGLE1_TYPE, TRIANGLE2_TYPE } from "shape-entities/types/shape"
import { isShapeContrastOk } from "app/helpers/colors";
import { TEXT_DECORATION_NONE } from "shape-entities/render-text"

const { min, max, abs, sin, cos, PI, round, atan2, sqrt, ceil } = Math

const ShapeStrokeLinesAndColorsForm = ({form, formName, shape, activeShapeId, change, handleChangeGradient}) => {
    const subFormName = `shapes.${activeShapeId}`

    const isContrastOk = isShapeContrastOk(shape)

    const allowGradients = [RECTANGLE_TYPE, CIRCLE_TYPE, TRIANGLE1_TYPE, TRIANGLE2_TYPE, CIRCLE_TEXT_TYPE, POLYGON_TYPE, BEZIER_TYPE, LINE_TYPE, ELLIPSE_TYPE].includes(shape.type)
    const allowShapeColor = [RECTANGLE_TYPE, RECTANGLE_EACH_LINE_TYPE, CIRCLE_TYPE, TRIANGLE1_TYPE, TRIANGLE2_TYPE, DASHED_FRAME_TYPE,
        POLYGON_TYPE, BEZIER_TYPE, TEXT_INSIDE_SHAPE_TYPE, CIRCLE_TEXT_TYPE, ELLIPSE_TYPE, RATING_TYPE].includes(shape.type)

    switch (shape.type) {
        default:
            return <React.Fragment>
                {(allowGradients || allowShapeColor) &&
                    <React.Fragment>
                        <GridCell style={{alignSelf: 'center'}}>{trans('fill')}
                            {allowShapeColor && isContrastOk === false && ![FRAME_TYPE, DASHED_FRAME_TYPE].includes(shape.type) &&
                                <span title={trans('low_contrast')}><Icon type={'exclamation-triangle'} color={Theme.orange} /></span>
                            }
                        </GridCell>
                        <GridCell>
                            <Grid cols={'1fr 1fr 1fr'} gap={'5px'}>
                                <GridCell></GridCell>

                                {allowGradients &&
                                    <SelectGradient
                                        gradientId={shape.gradient_id}
                                        handleChangeGradient={(gradient: Gradient) => handleChangeGradient(gradient, shape)}
                                    />
                                }

                                {allowShapeColor &&
                                    <GridCell title={trans('shape_color')} col={(!allowGradients || [DASHED_FRAME_TYPE, FRAME_TYPE].includes(shape.type)) ? 'span 2' : undefined}>
                                        <TransparentColor
                                            name={`${formName}.${subFormName}.color`}
                                            value={shape.color}
                                            notRequired={true}
                                            changeValue={(color: string) => change(formName, `${subFormName}.color`, color)}
                                            changeGradient={(gradient: Gradient) => {
                                                handleChangeGradient(gradient, shape)
                                            }}
                                        />
                                    </GridCell>
                                }
                            </Grid>
                        </GridCell>
                    </React.Fragment>
                }

                {(shape.text_decoration && shape.text_decoration !== TEXT_DECORATION_NONE) &&
                    <React.Fragment>
                        <GridCell style={{alignSelf: 'center'}}>{trans('text_decoration')}</GridCell>
                        <GridCell>
                            <Grid cols={'1fr 1fr 1fr'} gap={'5px'}>
                                <GridCell title={trans('text_decoration_color')}>
                                    <TransparentColor
                                        name={`${formName}.${subFormName}.text_decoration_color`}
                                        value={shape.text_decoration_color || shape.text_color || null}
                                        changeValue={(color: string) => change(formName, `${subFormName}.text_decoration_color`, color)}
                                        hideGradients={true}
                                    />
                                </GridCell>

                                <GridCell title={trans('text_decoration_linethickness')}>
                                    <NumericInput
                                        formName={formName}
                                        fieldName={'text_decoration_linethickness'}
                                        placeholder={'text_decoration_linethickness'}
                                        shapeIndex={shape.index}
                                        id={'text-decoration-linethickness'}
                                        min={1}
                                        max={100}
                                        step={1}
                                        units={'px'}
                                        value={shape.text_decoration_linethickness || ceil(shape.text_fontsize / 20)}
                                        onlyPositive={true}
                                    />
                                </GridCell>

                                <GridCell title={trans('text_decoration_lineoverlap')}>
                                    <NumericInput
                                        formName={formName}
                                        fieldName={'text_decoration_lineoverlap'}
                                        placeholder={'text_decoration_lineoverlap'}
                                        shapeIndex={shape.index}
                                        id={'text-decoration-lineoverlap'}
                                        min={0}
                                        max={100}
                                        step={1}
                                        units={'px'}
                                        value={shape.text_decoration_lineoverlap || 0}
                                        onlyPositive={true}
                                    />
                                </GridCell>
                            </Grid>
                        </GridCell>
                    </React.Fragment>
                }
            </React.Fragment>
    }
}

export default ShapeStrokeLinesAndColorsForm